import React from 'react';
import { collectionsData } from '../data/mock';
import { Card, CardContent } from './ui/card';

const CollectionsSection = () => {
  return (
    <section id="collections" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-light text-gray-800 mb-4 tracking-tight">
            Nos Collections
          </h2>
          <p className="text-lg text-rose-400 uppercase tracking-widest font-medium">
            Trouvez votre style unique
          </p>
        </div>

        {/* Collections Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {collectionsData.map((collection) => (
            <Card 
              key={collection.id}
              className="group overflow-hidden border-0 shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer bg-white"
            >
              {/* Image */}
              <div className="relative h-96 overflow-hidden">
                <img
                  src={collection.image}
                  alt={collection.name}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>
                
                {/* Overlay Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <h3 className="font-serif text-2xl font-light mb-2 tracking-tight">
                    {collection.name}
                  </h3>
                  <p className="text-sm text-white/90 mb-4 leading-relaxed">
                    {collection.description}
                  </p>
                  
                  {/* Items List */}
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                    <ul className="space-y-1 text-xs text-white/80">
                      {collection.items.map((item, idx) => (
                        <li key={idx} className="flex items-center">
                          <span className="w-1.5 h-1.5 bg-rose-400 rounded-full mr-2"></span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <CardContent className="p-6 bg-gradient-to-b from-rose-50/30 to-white">
                <button className="w-full py-3 text-sm font-medium tracking-wider uppercase text-rose-400 hover:text-white hover:bg-rose-400 border border-rose-400 rounded-sm transition-all duration-300">
                  Découvrir
                </button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-lg mb-6">
            Visitez notre boutique pour découvrir l'ensemble de nos collections
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block px-8 py-4 bg-rose-400 hover:bg-rose-500 text-white text-sm uppercase tracking-wider font-medium rounded-sm transition-all duration-300 shadow-md hover:shadow-lg"
          >
            Nous Contacter
          </button>
        </div>
      </div>
    </section>
  );
};

export default CollectionsSection;
